import { axiosPrivateInstance } from 'libs/axios';
import { UPDATE_RETURNED_STATUS } from 'utils/serviceUrls';

const updateReturnStatusService = async (id: any, message: any, isProductUpdate: boolean) => {
	const paramData = {
		url: 'string',
		agent: 'string',
		encProductId: id,
		statusId: 5,
		comment: message,
		isProductStatus: isProductUpdate,
	};
	// eslint-disable-next-line no-return-await
	return await axiosPrivateInstance
		.post(UPDATE_RETURNED_STATUS, paramData)
		.then((response: any) => {
			return response;
		})
		.catch(() => {
			return false;
		});
};

export default updateReturnStatusService;
